import React from 'react'
const TimeSelect = props => {
	const times = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'];
	return (
		<select value={props.value} onChange={props.handleTimeChange} disabled={!props.active}>
			<option value="">Time</option>
			{times.map((time, index) => {
				return (
					<option value={time} key={`time-`+time}>{time}</option>
				)
			})}
		</select>
	);
};
export default TimeSelect
